import { ReactNode } from "react"

interface HeaderFiltersProps {
  children?: ReactNode
  left?: ReactNode
  right?: ReactNode
  leftWidth?: string
}

function HeaderFilters({ children, left, right, leftWidth = "w-1/2" }: HeaderFiltersProps) {
  return (
    <div className="d-flex align-center justify-between filters">
      {left && <div className={`flex ${leftWidth} items-center`}>{left}</div>}

      {children}

      {right && <div>{right}</div>}
    </div>
  )
}

export default HeaderFilters
